import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const author = {
  fetchAuthor: lazyModuleMethod(() => import('./fetchAuthor'), 'default'),
  fetchAuthors: lazyModuleMethod(() => import('./fetchAuthors'), 'default'),
  searchAuthors: lazyModuleMethod(() => import('./searchAuthors'), 'default'),
  createAuthor: lazyModuleMethod(() => import('./createAuthor'), 'default'),
  editAuthor: lazyModuleMethod(() => import('./editAuthor'), 'default'),
  deleteAuthor: lazyModuleMethod(() => import('./deleteAuthor'), 'default'),
}
